if (!customElements.get('flower-modal')) {
  customElements.define(
    'flower-modal',
    class FlowerModal extends ModalDialog {
      constructor() {
        super();
        this.quantityInputs = [];
        this.totalPriceEl = null;
        this.submitButton = null;
        this.mainVariantId = null;
        this.selectedQuantities = new Map();
        this.isModifySession = false;
      }

      connectedCallback() {
        super.connectedCallback();
        if (this.initialized) return;
        this.initialized = true;

        this.mainVariantId = this.dataset.mainVariantId;
        this.totalPriceEl = this.querySelector('[data-total-price]');
        this.submitButton = this.querySelector('[data-submit-button]');

        this.mainForm = document.querySelector(
          `form[data-type="add-to-cart-form"]`
        );
        this.mainFormQuantity = this.mainForm
          ? this.mainForm.querySelector('input[name="quantity"]')
          : null;

        this.currentBundleId = this.generateBundleId();

        if (this.mainForm) {
          this.mainForm.addEventListener('submit', () => {
            this.syncToMainForm();
            this.selectedQuantities.clear();
          }, { capture: true });
          this.mainForm.addEventListener('change', () => {
            const qtyInput = this.mainForm.querySelector('input[name="quantity"]');
            if (qtyInput) {
              this.mainFormQuantityValue = parseInt(qtyInput.value, 10) || 1;
              this.updateButtonStates();
            }
            this.syncToMainForm();
          });
        }

        this.quantityInputs = this.querySelectorAll('[data-quantity-input]');

        this.onQuantityButtonClickBound = this.onQuantityButtonClick.bind(this);
        this.querySelectorAll('.flower-modal__qty-btn').forEach((btn) => {
          btn.addEventListener('click', this.onQuantityButtonClickBound);
        });

        this.onSubmitClickBound = this.onSubmitClick.bind(this);
        this.submitButton.addEventListener('click', this.onSubmitClickBound);

        // Listen for successful cart updates to rotate the bundle ID
        if (typeof subscribe === 'function') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'product-form') {
              this.currentBundleId = this.generateBundleId();
              this.resetSelections();
            }
          });
        }
      }

      generateBundleId() {
        return `bundle_${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
      }

      generateBundleNumber() {
        return Math.floor(10000 + Math.random() * 90000);
      }

      show(opener) {
        this.mainVariantId =
          this.dataset.mainVariantId ||
          document.querySelector('.product-variant-id')?.value;

        const mainForm = document.querySelector(
          `form[data-type="add-to-cart-form"]`
        );
        const qtyInput = mainForm
          ? mainForm.querySelector('input[name="quantity"]')
          : null;
        this.mainFormQuantityValue = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        // Detect if this is a modify session — user already has saved flower selections
        const badge = document.querySelector('[data-flower-count]');
        this.isModifySession = badge
          && !badge.classList.contains('hidden')
          && parseInt(badge.textContent, 10) > 0;

        super.show(opener);
        this.updateButtonStates();
      }

      hide() {
        super.hide();
      }

      resetSelections() {
        this.isModifySession = false;
        this.selectedQuantities.clear();
        this.quantityInputs.forEach((input) => {
          input.value = 0;
        });
        this.setTotalPrice(0);
        this.updateButtonStates();
        this.updateTriggerBadge();
        this.syncToMainForm();
      }

      onQuantityButtonClick(event) {
        const btn = event.currentTarget;
        const action = btn.dataset.action;
        const productEl = btn.closest('.flower-modal__product');
        const input = productEl.querySelector('[data-quantity-input]');
        const variantId = productEl.dataset.variantId;
        const price = parseInt(productEl.dataset.price, 10);
        const currentQty = parseInt(input.value, 10) || 0;

        const limit = this.mainFormQuantityValue * 10;
        const currentTotal = Array.from(this.selectedQuantities.values()).reduce((sum, item) => sum + item.quantity, 0);

        let newQty = currentQty;
        if (action === 'plus') {
          if (currentTotal >= limit) return;
          newQty = Math.min(currentQty + 1, parseInt(input.max, 10) || 99);
        } else if (action === 'minus') {
          newQty = Math.max(currentQty - 1, 0);
        }

        input.value = newQty;

        if (newQty > 0) {
          this.selectedQuantities.set(variantId, { quantity: newQty, price: price });
        } else {
          this.selectedQuantities.delete(variantId);
        }

        this.updateTotal();
        this.updateButtonStates();
        this.syncToMainForm();
      }

      updateButtonStates() {
        const limit = this.mainFormQuantityValue * 10;
        const currentTotal = Array.from(this.selectedQuantities.values()).reduce((sum, item) => sum + item.quantity, 0);
        
        this.querySelectorAll('.flower-modal__qty-btn[data-action="plus"]').forEach(btn => {
          btn.disabled = currentTotal >= limit;
        });
      }

      updateTotal() {
        let total = 0;
        this.selectedQuantities.forEach((item) => {
          total += item.price * item.quantity;
        });

        const hasSelection = this.selectedQuantities.size > 0;
        const submitText = this.submitButton.querySelector('[data-submit-text]');
        if (submitText) {
          if (this.isModifySession) {
            // When reopening to modify existing selections, always show modify text
            submitText.textContent = submitText.dataset.modifyText;
          } else {
            submitText.textContent = hasSelection
              ? submitText.dataset.confirmText
              : submitText.dataset.modifyText;
          }
        }
        this.setTotalPrice(total);
      }

      setTotalPrice(cents) {
        const formattedPrice = new Intl.NumberFormat(
          document.documentElement.lang || 'el-GR',
          { style: 'currency', currency: 'EUR' }
        ).format(cents / 100);

        this.totalPriceEl.textContent = formattedPrice;
      }

      onSubmitClick() {
        if (this.selectedQuantities.size === 0) {
          this.hide();
          return;
        }

        // Only confirm the selection — do NOT submit the main form.
        // The bundle will be added to cart when the user clicks the main "Add to Cart" button.
        this.syncToMainForm();
        this.updateTriggerBadge();
        this.hide();
      }


      syncToMainForm() {
        const sectionId = this.dataset.sectionId;
        const container = document.getElementById(`FlowerBundleInputs-${sectionId}`);
        if (!container) return;

        const mainForm = document.querySelector(`#product-form-${sectionId}`);
        if (!mainForm) return;

        // Clear existing bundle inputs
        container.innerHTML = '';

        const bundleId = this.currentBundleId;
        const bundleNumber = this.generateBundleNumber();
        const bundleItems = Array.from(this.selectedQuantities.entries())
          .filter(([id, data]) => data.quantity > 0)
          .map(([id, data]) => ({ id, quantity: data.quantity }));

        if (bundleItems.length === 0) return;

        // Add bundle metadata to the main product via its properties
        // These will be picked up by product-form.js and merged into the main item
        this.createHiddenInput(container, `properties[_bundle_id]`, bundleId);
        this.createHiddenInput(container, `properties[_bundle_type]`, 'parent');
        this.createHiddenInput(container, `properties[Bouquet]`, bundleNumber);

        // Add bundle flowers starting from index 0
        // product-form.js will merge the main product into this list
        bundleItems.forEach((item, index) => {
          this.createHiddenInput(container, `items[${index}][id]`, item.id);
          this.createHiddenInput(container, `items[${index}][quantity]`, item.quantity);
          this.createHiddenInput(container, `items[${index}][properties][_bundle_id]`, bundleId);
          this.createHiddenInput(container, `items[${index}][properties][_bundle_type]`, 'child');
          this.createHiddenInput(container, `items[${index}][properties][Bouquet]`, bundleNumber);
        });
      }

      createHiddenInput(container, name, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        container.appendChild(input);
      }

      updateTriggerBadge() {
        const trigger = document.querySelector('[data-flower-trigger]');
        if (!trigger) return;

        const badge = trigger.querySelector('[data-flower-count]');
        if (!badge) return;

        let totalQty = 0;
        this.selectedQuantities.forEach((item) => {
          totalQty += item.quantity;
        });

        badge.textContent = totalQty;
        badge.classList.toggle('hidden', totalQty === 0);
        trigger.classList.toggle('has-flowers', totalQty > 0);

        this.updateMainButtonText();
      }

      updateMainButtonText() {
        const mainSubmitButton = document.querySelector(`product-form [type="submit"]`);
        if (!mainSubmitButton) return;

        const mainSubmitButtonText = mainSubmitButton.querySelector('span');
        const isMerged = mainSubmitButton.classList.contains('button--merged-add-to-cart');
        if (!mainSubmitButtonText || isMerged) return;

        if (this.selectedQuantities.size > 0) {
          // Calculate total including main product?
          // For now, let's just show "Add to cart (Selection total: €XX.XX)"
          let selectionTotal = 0;
          this.selectedQuantities.forEach((item) => {
            selectionTotal += item.price * item.quantity;
          });

          const formattedTotal = new Intl.NumberFormat(
            document.documentElement.lang || 'el-GR',
            { style: 'currency', currency: 'EUR' }
          ).format(selectionTotal / 100);

          const baseText = window.variantStrings?.addToCart || 'Προσθήκη στο καλάθι';
          mainSubmitButtonText.textContent = `${baseText} (+ ${formattedTotal})`;
        } else {
          mainSubmitButtonText.textContent = window.variantStrings?.addToCart || 'Προσθήκη στο καλάθι';
        }
      }
    }
  );
}
